var _defs, _metadata, _rect, _g, _path, _g2, _path2, _g3, _g4, _path3, _circle, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1400 1133",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str1 {stroke:black;stroke-width:3.62391}\r\n    .str0 {stroke:black;stroke-width:31.9593}\r\n    .str2 {stroke:black;stroke-width:31.9593;stroke-linecap:round}\r\n    .fil0 {fill:none}\r\n    .fil4 {fill:black}\r\n    .fil1 {fill:#F6E3C5}\r\n    .fil3 {fill:white}\r\n    .fil2 {fill:white;fill-rule:nonzero}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700 211c-45,0 -305,9 -454,331 -181,390 157,438 454,438 297,0 635,-47 454,-438 -149,-322 -409,-331 -454,-331z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_214064408"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1400,
    height: 1133
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1084 395c0,0 246,133 214,316 -4,23 -10,54 -54,56 -44,2 -192,-83 -216,-123 -25,-40 56,-249 56,-249z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M316 395c0,0 -246,133 -214,316 4,23 10,54 54,56 44,2 192,-83 216,-123 24,-40 -56,-249 -56,-249z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M700 211c-45,0 -305,9 -454,331 -181,390 157,438 454,438 297,0 635,-47 454,-438 -149,-322 -409,-331 -454,-331z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "fil0 str1",
    cx: 21,
    cy: 355,
    rx: 23,
    ry: 48
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M700 211c-45,0 -305,9 -454,331 -181,390 157,438 454,438 297,0 635,-47 454,-438 -149,-322 -409,-331 -454,-331z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M617 658l-64 0 0 0 0 -3 0 -3 -1 -3 0 -3 -1 -2 0 -3 -1 -3 -1 -2 -1 -3 -1 -2 -1 -2 -2 -2 -1 -2 -1 -3 -2 -1 -2 -2 -1 -2 -2 -2 -2 -1 -2 -2 -1 -1 -2 -1 -2 -1 -2 -1 -2 -1 -2 -1 -2 0 -2 -1 -3 0 -2 -1 -2 0 -2 0 0 -64 6 0 5 1 6 1 5 1 6 1 5 2 5 2 6 2 4 2 5 3 5 3 4 3 5 3 4 4 4 4 3 4 4 4 3 4 4 4 3 5 2 5 3 5 2 5 2 5 2 5 2 5 1 6 1 6 1 5 1 6 0 6 1 6 0 0zm-110 117l0 -64 0 0 2 0 2 0 2 0 3 -1 2 0 2 -1 2 -1 2 -1 2 -1 2 -1 2 -1 1 -1 2 -2 2 -1 2 -2 1 -1 2 -2 2 -2 1 -2 1 -2 2 -3 1 -2 1 -2 1 -3 1 -2 1 -3 0 -2 1 -3 0 -3 1 -3 0 -2 0 -3 64 0 -1 5 0 6 -1 6 -1 6 -1 5 -1 6 -2 5 -2 5 -2 6 -2 5 -3 4 -2 5 -3 5 -4 4 -3 5 -4 4 -3 4 -4 3 -4 4 -5 3 -4 3 -5 3 -5 3 -4 2 -6 3 -5 2 -5 1 -6 2 -5 1 -6 0 -5 1 -6 0 0 0zm-110 -117l64 0 0 0 0 3 0 2 0 3 1 3 0 3 1 2 1 3 1 2 1 3 1 2 1 2 1 3 2 2 1 2 2 2 1 2 2 1 2 2 1 1 2 2 2 1 2 1 2 1 2 1 2 1 2 1 2 1 2 0 2 1 2 0 3 0 2 0 0 64 -6 0 -6 -1 -5 0 -6 -1 -5 -2 -6 -1 -5 -2 -5 -3 -5 -2 -5 -3 -4 -3 -5 -3 -4 -3 -4 -4 -4 -3 -4 -4 -3 -4 -4 -5 -3 -4 -3 -5 -3 -5 -2 -4 -3 -5 -2 -6 -2 -5 -1 -5 -2 -6 -1 -5 -1 -6 0 -6 -1 -6 0 -5 0 0zm110 -118l0 64 0 0 -2 0 -3 0 -2 1 -2 0 -2 1 -2 0 -2 1 -2 1 -2 1 -2 1 -2 1 -2 1 -2 2 -1 1 -2 2 -2 2 -1 2 -2 1 -1 3 -2 2 -1 2 -1 2 -1 2 -1 3 -1 2 -1 3 -1 3 0 2 -1 3 0 3 0 3 0 3 -64 0 0 -6 1 -6 0 -6 1 -5 1 -6 2 -6 1 -5 2 -5 2 -5 3 -5 2 -5 3 -5 3 -5 3 -4 4 -4 3 -4 4 -4 4 -4 4 -4 4 -3 5 -3 4 -3 5 -3 5 -2 5 -2 5 -2 6 -2 5 -1 6 -1 5 -1 6 -1 6 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M507 572c43,0 78,38 78,86 0,47 -35,85 -78,85 -43,0 -78,-38 -78,-85 0,-48 35,-86 78,-86z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 528,
    cy: 659,
    r: 71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M783 658l0 0 0 -6 1 -6 0 -6 1 -5 2 -6 1 -6 2 -5 1 -5 3 -5 2 -5 2 -5 3 -5 3 -5 3 -4 4 -4 3 -4 4 -4 4 -4 4 -4 4 -3 5 -3 5 -3 4 -3 5 -2 5 -2 6 -2 5 -2 5 -1 6 -1 5 -1 6 -1 6 0 0 64 -2 0 -3 0 -2 1 -2 0 -2 1 -2 0 -2 1 -2 1 -2 1 -2 1 -2 1 -2 1 -1 2 -2 1 -2 2 -2 2 -1 2 -2 1 -1 3 -2 2 -1 2 -1 2 -1 2 -1 3 -1 2 -1 3 0 3 -1 2 -1 3 0 3 0 3 0 3 0 0 -64 0zm110 117l0 0 -6 0 -6 -1 -5 0 -6 -1 -5 -2 -5 -1 -6 -2 -5 -3 -5 -2 -4 -3 -5 -3 -5 -3 -4 -3 -4 -4 -4 -3 -4 -4 -3 -4 -4 -5 -3 -4 -3 -5 -3 -5 -2 -4 -2 -5 -3 -6 -1 -5 -2 -5 -1 -6 -2 -5 -1 -6 0 -6 -1 -6 0 -5 64 0 0 3 0 2 0 3 1 3 1 3 0 2 1 3 1 2 1 3 1 2 1 2 1 3 2 2 1 2 2 2 1 2 2 1 2 2 2 1 1 2 2 1 2 1 2 1 2 1 2 1 2 1 2 1 2 0 2 1 2 0 3 0 2 0 0 0 0 64zm110 -117l0 0 0 5 -1 6 -1 6 0 6 -2 5 -1 6 -2 5 -2 5 -2 6 -2 5 -3 4 -2 5 -3 5 -4 4 -3 5 -3 4 -4 4 -4 3 -4 4 -5 3 -4 3 -5 3 -4 3 -5 2 -5 3 -6 2 -5 1 -5 2 -6 1 -6 0 -5 1 -6 0 0 -64 2 0 2 0 3 0 2 -1 2 0 2 -1 2 -1 2 -1 2 -1 2 -1 2 -1 2 -1 1 -2 2 -1 2 -2 2 -1 1 -2 2 -2 1 -2 1 -2 2 -3 1 -2 1 -2 1 -3 1 -2 1 -3 0 -2 1 -3 0 -3 1 -3 0 -2 0 -3 0 0 64 0zm-110 -118l0 0 6 0 5 1 6 1 6 1 5 1 5 2 6 2 5 2 5 2 4 3 5 3 4 3 5 3 4 4 4 4 4 4 3 4 3 4 4 4 3 5 2 5 3 5 2 5 2 5 2 5 2 5 1 6 2 6 0 5 1 6 1 6 0 6 -64 0 0 -3 0 -3 -1 -3 0 -3 -1 -2 0 -3 -1 -3 -1 -2 -1 -3 -1 -2 -1 -2 -2 -2 -1 -2 -1 -3 -2 -1 -1 -2 -2 -2 -2 -2 -2 -1 -1 -2 -2 -1 -2 -1 -2 -1 -2 -1 -2 -1 -2 -1 -2 0 -2 -1 -2 0 -3 -1 -2 0 -2 0 0 0 0 -64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M893 572c-43,0 -78,38 -78,86 0,47 35,85 78,85 43,0 78,-38 78,-85 0,-48 -35,-86 -78,-86z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 871,
    cy: 659,
    r: 71
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_214064840"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fil3",
    cx: 850,
    cy: 658,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil3",
    cx: 549,
    cy: 658,
    r: 28
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil3 str0",
    d: "M489 217c15,0 28,4 39,12 9,-48 51,-85 100,-85 8,0 17,1 24,3 14,-13 33,-21 54,-21 21,0 40,8 54,21 20,3 38,16 47,34 9,-7 20,-12 32,-12 25,0 46,20 49,44 12,-3 26,-5 40,-5 57,0 104,33 104,74 0,5 -1,9 -2,13 42,6 75,37 75,76 0,42 -40,77 -89,77 -12,0 -23,-3 -33,-6 -12,13 -31,21 -51,21 -19,0 -37,-7 -49,-20 -10,21 -33,36 -60,36 -23,0 -43,-11 -55,-28 -16,15 -47,26 -81,26 -26,0 -49,-6 -66,-15 -7,22 -32,38 -62,38 -35,0 -64,-23 -64,-50 0,-1 0,-2 0,-2 -13,7 -30,11 -49,11 -34,0 -63,-14 -71,-34 -6,2 -13,2 -19,2 -42,0 -76,-25 -76,-55 0,-31 34,-56 76,-56 1,0 3,0 4,0 -2,-4 -3,-8 -3,-13 0,-24 26,-43 58,-43 5,0 9,0 14,1 3,-25 29,-44 60,-44z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 700,
    cy: 829,
    r: 51
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_214064312"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M700 829c0,23 1,46 0,69 -3,34 -77,39 -82,-22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M700 829c0,23 -1,46 0,69 3,34 77,39 82,-22"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni2);
export default __webpack_public_path__ + "static/media/ani2.8ad2f176831028e38e8eba3cb1dcfd87.svg";
export { ForwardRef as ReactComponent };